export enum PRODUCTS_UID {
  MqttBridge = '577ECC8D-2C4A-4E9A-885B-823CA2EC8A19',
}
